import React, { Component } from 'react';
import { Modal, Checkbox } from 'react-bootstrap';
import { CCOButton } from '../util/Components.js';
import { get, update, post } from '../util/Utility';
import moment from 'moment';

class EventPaymentModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      payments: [],
      paid: {},
      originalPaid: {}
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show && !this.props.show) {
      this.setState({payments: [], paid: {}, originalPaid: {}, working: true}, () => get("events/" + newProps.event.key + "/rsvp", this, null, null, false).then(data => {
        Object.keys(data).forEach(item => {
          get("payments/" + newProps.event.ministryID + "/" + newProps.event.key + "/" + item, this, null, null, false).then(data => {
            if (!data.removed) {
              let obj = this.state.payments;
              let paid = this.state.paid;
              let originalPaid = this.state.originalPaid;
              paid[item] = data.paid;
              originalPaid[item] = data.paid;
              obj.push({...data, key: item});
              this.setState({payments: obj, paid, originalPaid});
            }
          });
        });
      }));
    }
  }

  save() {
    Object.keys(this.state.paid).forEach(uid => {
      if (this.state.paid[uid] !== this.state.originalPaid[uid]) {
        update("payments/" + this.props.event.ministryID + "/" + this.props.event.key + "/" + uid, this, {paid: this.state.paid[uid]});
        post("payments/" + this.props.event.ministryID + "/" + this.props.event.key + "/" + uid + "/log/" + moment().unix(), this, {new_paid: this.state.paid[uid], user: this.props.user.uid});
      }
    })
    this.props.done();
  }

  render() {
    var divStyle = {
      maxWidth: 700,
      color: 'black'
    };

    var rows = this.state.payments.map(item => {
      const { full_name, email, name_of_payer, payment_method, key } = item;
      return (
        <tr key={key}>
          <td>{full_name}</td>
          <td>{email}</td>
          <td>{key}</td>
          <td>{name_of_payer}</td>
          <td>{payment_method}</td>
          <td><div style={{marginTop: 13}}><Checkbox checked={this.state.paid[key]} onChange={() => {
            let paid = this.state.paid;
            paid[key] = !paid[key];
            this.setState({paid});
          }} /></div></td>
        </tr>
      )
    });

    let total = this.state.payments.reduce((sum, payment) => sum + payment.amount, 0);

    return (
      <div style={divStyle}>
        <Modal show={this.props.show}>
          <Modal.Header>
            <Modal.Title>Event Payments for {this.props.event.title}</Modal.Title>
            <p>Total Collected (after processing fees): ${total}</p>
          </Modal.Header>

          <Modal.Body>
            {rows.length === 0 ?
              <center><p>No Payments Yet</p></center>
              :
              <table className="rsvpTable">
                <thead>
                  <tr>
                    <th>Participant Name</th>
                    <th>Email</th>
                    <th>Customer ID</th>
                    <th>Name of Payer</th>
                    <th>Payment Method</th>
                    <th>Recieved Payment</th>
                  </tr>
                </thead>
                <tbody>
                  {rows}
                </tbody>
              </table>
            }
          </Modal.Body>

          <Modal.Footer>
            <center>
              <div style={{width: 200}}>
                <CCOButton onClick={() => this.save()} text="Save" type="primary" />
                <div style={{height: 10}} />
                <CCOButton onClick={this.props.done} text="Cancel" type="primary" />
              </div>
            </center>
          </Modal.Footer>

        </Modal>
      </div>
    );
  }
}

export default EventPaymentModal;



/** WEBPACK FOOTER **
 ** ./src/financial/EventPaymentsModal.js
 **/